import React from "react";
import { Controller } from "react-hook-form";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { FormControl, InputAdornment } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import dayjs from "dayjs";

const CustomDateTimePicker = ({
  control,
  trigger,
  name,
  minDate,
  maxDate,
  label,
  error,
  helperText,
  handleBlur,
  disabled = false,
}) => {
  return (
    <FormControl fullWidth margin="normal">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <DateTimePicker
              {...field}
              label={label}
              value={field.value || null}
              disabled={disabled}
              views={["year", "month", "day", "hours", "minutes"]}
              format="MM/DD/YYYY hh:mm A"
              ampm
              onChange={(newValue) => {
                if (disabled) return;
                // Default time to midnight if the incoming value has no time set
                // (i.e. user picked a date but time is still 00:00 from the picker default)
                let valueToSet = newValue;
                if (newValue && !field.value) {
                  // First time setting — pin to midnight
                  valueToSet = dayjs(newValue).startOf("day");
                }
                field.onChange(valueToSet);
                if (trigger) trigger(name);
              }}
              minDate={minDate}
              maxDate={maxDate}
              slotProps={{
                textField: {
                  name,
                  variant: "outlined",
                  disabled,
                  onBlur: (e) => {
                    field.onBlur(e);
                    if (handleBlur) handleBlur(e);
                  },
                  helperText,
                  error: !!error,
                  InputProps: (params) => {
                    const endAdornment = (
                      <>
                        {params.endAdornment}
                        {error && (
                          <InputAdornment position="end">
                            <ErrorIcon style={{ color: "red" }} />
                          </InputAdornment>
                        )}
                      </>
                    );
                    return { ...params, endAdornment };
                  },
                },
              }}
            />
          )}
        />
      </LocalizationProvider>
    </FormControl>
  );
};

export default CustomDateTimePicker;